import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import { chatDashboardSettingsSet } from '../../../../../../../../../rest/effects/chatDashboardSettings/chatDashboardSettingsSet';
import { getChatDashboardSettingsByBoardId } from 'app/store/model/chatDashboardSettings/selectors/getChatDashboardSettingsByBoardId';

export const onChange = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const isEnabled = !!getChatDashboardSettingsByBoardId(state, boardId).enabled;
        dispatch(segmentTrackAction(SegmentBoardEvent.CLICKED_CHATS));
        dispatch(chatDashboardSettingsSet(boardId, {enabled: !isEnabled}))
    };

    return action;
};
